import api from './api';

const API_URL = '/api/homepage';

// Get homepage content
const getHomePageContent = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching homepage content:', error);
    throw error;
  }
};

// Update homepage content (Super Admin only)
const updateHomePageContent = async (contentData) => {
  try {
    const response = await api.put(API_URL, contentData);
    return response.data;
  } catch (error) {
    console.error('Error updating homepage content:', error);
    throw error;
  }
};

const homePageService = {
  getHomePageContent,
  updateHomePageContent
};

export default homePageService; 